/**
 * Place a version menu below its trigger, clamped to the viewport.
 * Used instead of Radix collision — the KPI header is too short and
 * --radix-dropdown-menu-content-available-height clips the list.
 *
 * Fill/color are inline so Tailwind utilities cannot lose to an unset
 * --popover token or an inherited --tw-bg-opacity (transparent panel).
 */
export const VERSION_MENU_SURFACE = {
  backgroundColor: '#ffffff',
  color: '#111827',
  opacity: 1,
  isolation: 'isolate',
};

export function versionMenuPosition(triggerRect, { width = 256, maxHeight = 360, pad = 8, gap = 6, viewport } = {}) {
  if (!triggerRect) return null;
  const vw = viewport?.width ?? (typeof window !== 'undefined' ? window.innerWidth : 1024);
  const vh = viewport?.height ?? (typeof window !== 'undefined' ? window.innerHeight : 768);
  const menuWidth = Math.min(width, Math.max(160, vw - pad * 2));
  let left = triggerRect.left;
  if (left + menuWidth > vw - pad) left = vw - pad - menuWidth;
  if (left < pad) left = pad;

  const below = vh - triggerRect.bottom - gap - pad;
  const above = triggerRect.top - gap - pad;
  const placeBelow = below >= 120 || below >= above;
  const available = Math.max(96, placeBelow ? below : above);
  const height = Math.min(maxHeight, available);
  const top = placeBelow ? triggerRect.bottom + gap : Math.max(pad, triggerRect.top - gap - height);

  return {
    position: 'fixed',
    top,
    left,
    width: menuWidth,
    maxHeight: height,
    ...VERSION_MENU_SURFACE,
  };
}
